import React from 'react';
import './Footer.scss';

const FOOTER_COLUMNS = [
  {
    id: 'plateforme',
    heading: 'Plateforme',
    links: [
      { label: "À propos d'UNFM 2.0", href: '/a-propos' },
      { label: 'Indicateurs & rapports publics', href: '/indicateurs' },
      { label: 'Devenir partenaire', href: '/devenir-partenaire' },
    ],
  },
  {
    id: 'espaces',
    heading: 'Espaces',
    links: [
      { label: 'Espace femme', href: '/espace-femme' },
      {
        label: 'Espace association / formateur',
        href: '/espace-professionnel',
      },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    id: 'legal',
    heading: 'Légal',
    links: [
      { label: 'Politique de confidentialité', href: '/confidentialite' },
      { label: 'Mentions légales', href: '/mentions-legales' },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="unfm-footer">
      <div className="unfm-footer__container">
        <div className="unfm-footer__brand">
          <span className="unfm-footer__logo">UNFM 2.0</span>
          <p className="unfm-footer__tagline">
            Orienter, former, insérer.
          </p>
        </div>

        {FOOTER_COLUMNS.map((col) => (
          <div className="unfm-footer__column" key={col.id}>
            <h3 className="unfm-footer__heading">{col.heading}</h3>

            <ul className="unfm-footer__links">
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="unfm-footer__link"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </footer>
  );
};

export default Footer;